export default "__VITE_ASSET__DYPd4NMh__"